export default __webpack_public_path__ + "static/media/tibet.c2561b69.svg";